export const stateLogos = {
  Karnataka: "/state/karnataka.png",
  Kerala: "/state/kerala1.png",
  "Tamil Nadu": "/state/tamilnadu1.png",
  "Madhya Pradesh": "/state/MadhyaPradesh.png"
};